module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.singleComment) ? _c('div', [_vm._v("\n    标题：\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.singleComment.title),
      expression: "singleComment.title"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.singleComment.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.singleComment.title = $event.target.value
      }
    }
  }), _vm._v(" 类目：\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.singleComment.subtitle),
      expression: "singleComment.subtitle"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.singleComment.subtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.singleComment.subtitle = $event.target.value
      }
    }
  }), _vm._v(" 等级：\n    "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.singleComment.rating),
      expression: "singleComment.rating"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.singleComment.rating)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.singleComment.rating = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" 内容：\n    "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.singleComment.content),
      expression: "singleComment.content"
    }],
    attrs: {
      "name": "",
      "id": ""
    },
    domProps: {
      "value": (_vm.singleComment.content)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.singleComment.content = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', [_c('a', {
    attrs: {
      "href": "#/db/"
    },
    on: {
      "click": _vm.showAlert
    }
  }, [_vm._v("保存")])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b96d1f5"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/mod.vue
// module id = 238
// module chunks = 0